import { useStore } from '../../store/StoreContext';
import { ScreenHeader } from '../../components/ui/ScreenHeader';
import { FormSection } from '../../components/ui/FormSection';
import { Toggle } from '../../components/ui/Toggle';

// Device-local connectivity preference (localStorage only, like the
// Appearance layout toggle and the Diagnostics connection badge). Its one
// job is to cut background data use on a slow or metered connection - see
// StoreContext's `manualRefresh` comment for exactly which fetches it
// suppresses.
export function ConnectionScreen() {
  const { manualRefresh, setManualRefresh, diagnosticsMenuEnabled, setDiagnosticsMenuEnabled } = useStore();

  return (
    <div className="flex flex-col gap-5">
      <ScreenHeader title="Connection" />

      <FormSection title="Data usage">
        <Toggle
          label="Manual refresh only"
          checked={manualRefresh}
          onChange={setManualRefresh}
        />
        <p className="text-sm text-black/55 dark:text-white/55 m-0 leading-relaxed">
          For a slow, unstable, or metered connection. While this is on, the
          app never refreshes lists or message history on its own — not on
          launch, not on sign-in, not when you open a screen — and it stops
          polling AI report jobs. It shows the last data it already has and
          waits for you.
        </p>
        <p className="text-sm text-black/55 dark:text-white/55 m-0 leading-relaxed">
          A refresh button appears on every list, chat, and report screen so
          you can pull fresh data exactly when you want it. Sending and
          receiving messages and signals over the live connection keeps
          working normally — only the extra background fetching is paused.
        </p>
        <p className="text-sm text-black/55 dark:text-white/55 m-0 leading-relaxed">
          Turn it off and the app goes back to refreshing automatically and
          hiding those buttons.
        </p>
      </FormSection>

      <FormSection title="Diagnostics">
        <Toggle
          label="Diagnostic menu"
          checked={diagnosticsMenuEnabled}
          onChange={setDiagnosticsMenuEnabled}
        />
        <p className="text-sm text-black/55 dark:text-white/55 m-0 leading-relaxed">
          Adds a Diagnostics tab to the main navigation with live detail on
          the signaling connection — heartbeats, channel joins, and every
          message and signal this device has sent or received. Off by
          default; turn it on only when you need to look into a connection
          problem.
        </p>
      </FormSection>
    </div>
  );
}
